export const pagesEndpoint = 'https://pagedev.co.uk/clients/fmc-almanac/wp-json/acf/v3/pages'
export const eventsEndpoint = 'https://pagedev.co.uk/clients/fmc-almanac/wp-json/acf/v3/events?per_page=500'
export const categoriesEndpoint = 'https://pagedev.co.uk/clients/fmc-almanac/wp-json/wp/v2/categories'